export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./locale.vue?vue&type=template&id=130e7ba7&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/locale.vue?vue&type=template&id=130e7ba7&
// module id = 1576
// module chunks = 0